module.exports = __webpack_public_path__ + "media/images/gallery/eclipses/2000-12-25/2000-12-25_blank-f983f2441024261d0ef3a18c0b4c370f.gif";